import en from './i18n/en.json';
import es from './i18n/es.json';

const DICTS = { en, es };
let lang = 'en';

// English unless the user explicitly picked another language (saved on their account,
// or in this browser before they sign in).
export function detectLang(pref) {
  if (pref && DICTS[pref]) return pref;
  try { const saved = localStorage.getItem('atnd-lang'); if (saved && DICTS[saved]) return saved; } catch { /* private mode */ }
  return 'en';
}
export function rememberLang(l) { try { localStorage.setItem('atnd-lang', l); } catch { /* ignore */ } }
export function setLang(l) {
  lang = DICTS[l] ? l : 'en';
  document.documentElement.lang = lang;
}
export const getLang = () => lang;

export function t(key, vars = {}) {
  const s = DICTS[lang][key] ?? DICTS.en[key] ?? key;
  return s.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ''));
}

/** BCP-47 locale for dates/times, always matching the app language (not the browser's). */
export const locale = () => (lang === 'es' ? 'es' : 'en');
